import React from 'react';
import { Route, Routes } from 'react-router';
import { usePageTitle } from '../../config';
import CustomerGroups from './CustomerGroups';
import CustomerGroupDetails from './CustomerGroupDetails';
import { PageErrorBoundary } from './components/Errors';
import { QueryErrorResetBoundary } from 'react-query';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';

export function CustomerGroupsRoute() {
  const { updatePageTitle } = usePageTitle();

  updatePageTitle('Customer Groups - Xvantage GDS');

  return (
    <NestedApiLocalizationProvider
      preloadResources={['CustomerGroups', 'Common', 'Pagination']}
    >
      <QueryErrorResetBoundary>
        {({ reset }) => (
          <PageErrorBoundary onReset={reset}>
            <Routes>
              <Route element={<CustomerGroups />} path="" />
              <Route element={<CustomerGroupDetails />} path="/:id" />
            </Routes>
          </PageErrorBoundary>
        )}
      </QueryErrorResetBoundary>
    </NestedApiLocalizationProvider>
  );
}
